import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';

/** Wraps a handler so nested controls (chips, buttons) do not trigger the row click. */
export function stopRowClickPropagation(handler) {
  if (!handler) return undefined;
  return (event) => {
    event.stopPropagation();
    handler(event);
  };
}

export default function ClickableTableRow({ onClick, children, sx, hover = true, ...other }) {
  const clickable = Boolean(onClick);

  return (
    <TableRow
      hover={hover && clickable}
      onClick={onClick}
      sx={[
        clickable && {
          cursor: 'pointer',
          '&:hover': { bgcolor: 'rgba(31, 91, 64, 0.04) !important' }
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
      ]}
      {...other}
    >
      {children}
    </TableRow>
  );
}

ClickableTableRow.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  hover: PropTypes.bool
};
